"use client";

import { Grid, Tab, TabList, TabGroup, TabPanel, TabPanels } from "@tremor/react";
import { useSelector } from 'react-redux';
import { Skeleton } from "@mui/material";
import { CalculateTimesByStore, ComputeCurrentCmvKpi, PerformanceByStore, ProductionPerformanceSummary } from "./helper";
import { isLoading } from "../component/loading/store";
import ListFranchise from "./list";
import AreaChartPerformace from "./chart";
import ComparativeCardKpi from "../component/comparativeCardKpi";
import useTrademarkFilter from "../../hooks/useTrademarkFilter";

export default function Franchise() {
    const kpiPerformance = useSelector((state) => state.kpiPerformance)
    const loadingKpiPerformance = useSelector((state) => isLoading(state, 'KPI_PERFORMANCE_STORE'))

    // faz o filtro das listas de performance por marca selecionada pelo usuário
    const filteredKpiPerformance = useTrademarkFilter(kpiPerformance)

    const performanceByStoreKPI = PerformanceByStore(filteredKpiPerformance, 'TOTAL')
    const chartComputeGlobalCmvKpi = ComputeCurrentCmvKpi(filteredKpiPerformance)

    return (
        <TabGroup className="mt-1">
            <TabList>
                <Tab>Visão geral</Tab>
                <Tab>Listagem</Tab>
            </TabList>
            <TabPanels>
                <TabPanel>
                    <>
                        <Grid numItemsSm={1} numItemsMd={2} numItemsLg={3} className="gap-6 mt-6">
                            {!loadingKpiPerformance ? (
                                <ComparativeCardKpi {...chartComputeGlobalCmvKpi} />
                            ) : (
                                <Skeleton variant="rounded" height={150} />
                            )}
                        </Grid>

                        <Grid className="gap-6 mt-6">
                            {!loadingKpiPerformance ? (
                                <AreaChartPerformace performanceByStore={performanceByStoreKPI} />
                            ) : (
                                <>
                                    <Skeleton variant="rounded" height={150} />
                                    <Skeleton variant="rounded" height={150} />
                                    <Skeleton variant="rounded" height={150} />
                                    <Skeleton variant="rounded" height={150} />
                                </>
                            )}
                        </Grid>
                    </>
                </TabPanel>
                <TabPanel>
                    <ListFranchise data={filteredKpiPerformance?.listAll || []} />
                </TabPanel>
            </TabPanels>
        </TabGroup>
    )
}
